import React, { ReactElement } from "react";
import styled from "styled-components";
import { LabelAndValueStyles } from "../../types/styles";

const LabelAndValueWrapper = styled.div<{
  styles: LabelAndValueStyles;
}>`
  display: grid;
  grid-template-columns: 35% 65%;
  column-gap: 10px;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  font-size: 13px;
  line-height: 20px;
  color: ${({ styles }) => styles.OverallGeneralTextColour};
`;

const FieldName = styled.div`
  align-self: start;
`;

const Value = styled.div`
  font-weight: 500;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
`;

export type LabelAndValueProps = {
  fieldName: string;
  children: string | ReactElement;
  styles: LabelAndValueStyles;
  dataId?: string;
};

export const LabelAndValue: React.FC<LabelAndValueProps> = ({
  fieldName,
  children,
  styles,
  dataId,
}) => {
  return (
    <LabelAndValueWrapper styles={styles} data-id={`${dataId}-container`}>
      <FieldName data-id={`${dataId}-field-name`}>{fieldName}</FieldName>
      <Value data-id={`${dataId}-value`}>{children}</Value>
    </LabelAndValueWrapper>
  );
};

export default LabelAndValue;
